module.exports = __webpack_public_path__ + "static/media/bell.f3a3031d.svg";